import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { InvitationLocationContent } from 'components/invitation/InvitationLocationContent';
import './InvitationLocation.css';

export const InvitationLocation = () => {
    const navigate = useNavigate();
    const { inviteCode } = useParams();
    const [locationGranted, setLocationGranted] = useState(false);

    const handleAllowLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocationGranted(true);
                    setTimeout(() => {
                        navigate(`/invitation/result/${inviteCode}`);
                    }, 500);
                },
                (error) => {
                    console.error('Location permission denied:', error);
                    navigate(`/invitation/result/${inviteCode}`);
                }
            );
        } else {
            navigate(`/invitation/result/${inviteCode}`);
        }
    };

    const handleSkip = () => {
        navigate(`/invitation/result/${inviteCode}`);
    };

    return (
        <div className="invitation-location-wrapper">
            <Header title="위치 권한" isSubPage />

            <div className="invitation-location-content">
                <InvitationLocationContent
                    locationGranted={locationGranted}
                    onAllowLocation={handleAllowLocation}
                    onSkip={handleSkip}
                />
            </div>
        </div>
    );
};
